/* 
    A handy wrapper to et.state
*/
define('shared/util/state',[
    'shared/lib/RSVP', 
    './defer', 
    'shared/lib/Emitter', 
    'shared/lib/console'
], 
function( RSVP, deferUtil, Emitter, console ){
    "use strict";

    var g = window;

    g.et = g.et || {};
    g.et.state = g.et.state || [];

    var adapterPromises = [];

    var state = {

        adapters: {
            /*
             * Helper to add adapter
             */
            add: function( adapter ) {
                var ret;

                if ( adapter == null ) {
                    return RSVP.resolve();
                }

                for ( var l = adapterPromises.length; l--; ) {
                    // check if the adapter is already added
                    if ( adapterPromises[l].adapter == adapter ) {
                        return adapterPromises[l];
                    }
                }

                ret = new RSVP.Promise(function(resolve, reject){
                    state.on('ready', function(){
                        g.et.state.addAdapters( adapter ).then( resolve, reject );
                    });
                });
                ret.adapter = adapter;

                adapterPromises.push( ret );

                return ret;
            }
        },

        onReady: function( func, avoidWait ){
            g.et.state.push(null, function(){
                var adapters;
                if ( avoidWait ) {
                    func();
                }
                else {
                    RSVP.all( adapterPromises )
                        .then(function(){
                            // To make sure adapters which added later are truely added.
                            setTimeout(function(){
                                func();
                            }, 0);
                        });
                }
            });
        },
        /* 
            Insert the data to the front of queue if possible
        */
        unshift: function(){
            var ret = RSVP.defer();
            var args = arguments;

            if ( g.et.state.unshift ) {
                g.et.state.unshift.apply( g.et.state, args );
                ret.resolve();
            }
            else {
                g.et.state.push.apply( g.et.state, args );
                ret.reject();
            }

            return ret.promise;
        },
        /*
            Push data into state
        */
        push: function () {
            var ret = RSVP.defer();
            var args = arguments;

            this.onReady(function(){
                var promise = g.et.state.put.apply( g.et.state, args );

                if ( deferUtil.isPromise( promise ) ){
                    promise.then(ret.resolve, ret.reject);
                }
                else {
                    ret.reject("et.state is not ready yet.");
                }
            });

            return ret.promise;
        },
        /*
            Get the data from state, if the value is empty, return directly
        */
        get: function (key) {
            var ret = RSVP.defer();
            var args = arguments;

            this.onReady(function(){
                if ( g.et.state.get == null ) {
                    ret.reject("et.state is not ready yet.");
                    return;
                }

                var promise = g.et.state.get.apply( g.et.state, args );

                if ( deferUtil.isPromise( promise ) ){
                    promise.then(ret.resolve, ret.reject);
                }
                else {
                    ret.reject("et.state is not ready yet.");
                }
            });

            return ret.promise;
        },
        /* 
            Resolve only after value is set (not null or undefined)
        */
        retrieve: function( key ){
            var handler;
            console.log( 'shared/util/state:', key + ' is being retrieved ' );
            return new RSVP.Promise(function( resolve, reject ){

                (function loop() { 
                    state.get( key )
                        .then(function( values ){
                            if ( values[0] == null ) {
                                setTimeout( loop, 500 );
                            }
                            else {
                                console.log( 'shared/util/state:', key + ' retrieving is done ' );
                                resolve( values[0] );
                            }
                        });
                })();
                
            });
        }
    }

    Emitter(state);

    state.onReady( function(){
        /*
            Event: ready
            Fire when et.state is ready to interact.
        */
        state.reemit('ready');
        state.isReady = true;
    }, true ); 

    state.onReady( function(){
        /*
            Event: dataready
            Fire after data adapters (which are added before dom ready) are properly initialized.
        */
        state.reemit('dataready');
        state.isDataReady = true;
    } ); 

    return state;

});
